import { render, staticRenderFns } from "./form15.vue?vue&type=template&id=3b4e332e&scoped=true"
import script from "./form15.vue?vue&type=script&lang=js"
export * from "./form15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e332e",
  null
  
)

export default component.exports